import {Address} from 'coreStore/data/orders/types';

/**
 * Represents an address (shipping|billing)
 */
class AddressModel {
	private address: Address;

	/**
	 * @constructor
	 * @param {Address} address - address
	 */
	constructor(address) {
		this.address = address;
	}

	/**
	 * Returns address first line
	 * @returns {string} address1 line
	 */
	getAddress1() {
		return this.address.address1;
	}

	/**
	 * Returns address second line
	 * @returns {string} address2 line
	 */
	getAddress2() {
		return this.address.address2;
	}

	/**
	 * Returns address city
	 * @returns {string} city
	 */
	getCity() {
		return this.address.city;
	}

	/**
	 * Returns country code
	 * @returns {String} countryCode
	 */
	getCountryCode() {
		if (typeof this.address.countryCode === 'object') {
			return (this.address.countryCode as {value: string}).value;
		}

		return this.address.countryCode;
	}

	/**
	 * Returns postal code
	 * @returns {string} postalCode
	 */
	getPostalCode() {
		return this.address.postalCode;
	}

	/**
	 * Returns first name
	 * @returns {string} first Name
	 */
	getFirstName() {
		return this.address.firstName;
	}

	/**
	 * Returns last name
	 * @returns {string} last Name
	 */
	getLastName() {
		return this.address.lastName;
	}

	/**
	 * Returns full name
	 * @returns {string} full Name
	 */
	getFullName() {
		return this.address.fullName;
	}

	/**
	 * Returns phone
	 * @returns {string} phone
	 */
	getPhone() {
		return this.address.phone;
	}

	/**
	 * Returns state code
	 * @returns {string} state code
	 */
	getStateCode() {
		return this.address.stateCode;
	}
}

export default AddressModel;
